import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const { user } = useSelector((state) => state.auth);

  const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 100);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const updateHeight = () => {
      const availableHeight = window.innerHeight - 190;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  return (
    <div className="mt-[.25rem] relative">
      {isLoading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-white z-10"
          style={{ height: iframeHeight }}
        >
          <div className="flex flex-col items-center gap-3">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="text-gray-600">Loading map...</p>
          </div>
        </div>
      )}
      <iframe
        src={`${url}/nia_schemes.php`}
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Dynamic Iframe"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
}

export default LeafletMap;
